<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="name">Name</label>
                    <input id="name" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
        </div>

        <div class="row action-toolbar">
            <div class="col-12">
                <label for="usersList">Add/Exclude By Condition</label>
                <form class="form-inline">
                    <action-toolbar-count [grid]="criteriaGrid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="criteriaGrid.filter"></action-toolbar-search>

                    <div class="btn-group">
                        <button id="btnAdd" type="button" class="btn btn-sm btn-secondary" (click)="addEditItem(true)">
                            <fa-icon class="d-none d-sm-inline-block" [icon]="faPlus"></fa-icon> Add
                        </button>

                        <button
                            id="btnEdit"
                            type="button"
                            class="btn btn-sm btn-secondary"
                            (click)="addEditItem(false)"
                            [disabled]="!criteriaGrid.hasItemSelected"
                        >
                            <fa-icon class="d-none d-sm-inline-block" [icon]="faPencil"></fa-icon> Edit
                        </button>

                        <button
                            id="btnDelete"
                            type="button"
                            class="btn btn-sm btn-secondary"
                            (click)="deleteCriteria()"
                            [disabled]="!criteriaGrid.hasItemSelected"
                        >
                            <fa-icon class="d-none d-sm-inline-block" [icon]="faXmark"></fa-icon> Delete
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <wj-flex-grid
                        id="gridCriteria"
                        #gridCriteria
                        style="height: 175px"
                        (initialized)="criteriaGrid.initialize(gridCriteria)"
                        [itemsSource]="criteriaGrid.view"
                        (dblclick)="addEditItem(false)"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Type'"
                            [binding]="'attributeName'"
                            [dataMap]="criteriaMap"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Value'" [binding]="'attributeValueName'" [width]="'*'"> </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Status'"
                            [binding]="'operator'"
                            [dataMap]="operatorMap"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>

        <div class="row action-toolbar">
            <div class="col-12">
                <label for="usersList">Include/Exclude Specific Employees</label>
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        style="height: 250px"
                        (initialized)="grid.initialize(mainGrid)"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Include'" [binding]="'include'" [width]="95" [align]="'center'">
                            <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                {{ cell.col.header }}<br />
                                <input id="include" type="checkbox" (change)="toggleAllCheckboxes($event)" />
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Exclude'" [binding]="'exclude'" [width]="95" [align]="'center'">
                            <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                {{ cell.col.header }}<br />
                                <input id="exclude" type="checkbox" (change)="toggleAllCheckboxes($event)" />
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Name'"
                            [binding]="'displayName'"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Position Code'"
                            [binding]="'positionCode'"
                            [dataMap]="positionCodeMap"
                            [width]="'*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'PR Group'"
                            [binding]="'prgroup'"
                            [dataMap]="prGroupMap"
                            [width]="120"
                            [align]="'left'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'PR Dept'"
                            [binding]="'prdept'"
                            [dataMap]="prDeptMap"
                            [width]="150"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Earn Code'"
                            [binding]="'earnCode'"
                            [dataMap]="earnCodeMap"
                            [width]="150"
                            [align]="'left'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Craft/Class'"
                            [binding]="'stdClass'"
                            [width]="125"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>

                    <!-- <wj-list-box
                        #usersList
                        class="form-control"
                        style="height: 300px; padding: 0"
                        [itemsSource]="users"
                        [displayMemberPath]="'displayName'"
                        [checkedMemberPath]="'checked'"
                    ></wj-list-box> -->
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
